// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3NuHH","header":"MergedInvoice_header__ljz2b"};